<template>
  <v-card
    flat
    class="pa-3 mt-1 ml-1"
  >
    <v-row>
      <v-card-title>
        Editar tipo de solicitação
        <v-chip
          small
          class="ml-2"
          :color="tipoSolicitacaoDataLocale.ativo ? 'success' : 'error'"
          outlined
        >
          {{ tipoSolicitacaoDataLocale.ativo ? 'Ativo' : "Inativo" }}
        </v-chip>
      </v-card-title>
    </v-row>

    <v-form class="multi-col-validation">
      <v-row class="d-flex align-center">
        <v-col
          md="6"
          cols="12"
        >
          <v-text-field
            v-model="tipoSolicitacaoDataLocale.nome"
            label="Nome"
            dense
            outlined
          ></v-text-field>
        </v-col>
      </v-row>

      <v-row>
        <v-col
          md="12"
          cols="12"
        >
          <v-textarea
            v-model="tipoSolicitacaoDataLocale.descricao"
            label="Descrição"
            dense
            outlined
          ></v-textarea>
        </v-col>
      </v-row>

      <!-- Salvar -->
      <v-btn
        color="primary"
        class="me-3 mt-3 mb-3"
        @click="update"
      >
        <v-progress-circular
          v-if="loading"
          indeterminate
          class="me-2"
        >
        </v-progress-circular>

        <span v-else>
          Salvar alterações
        </span>
      </v-btn>

      <v-btn
        color="secondary"
        outlined
        class="me-3 mt-3 mb-3"
        @click.prevent="resetForm"
      >
        Cancelar
      </v-btn>
    </v-form>
  </v-card>
</template>

<script>
import { mdiClose, mdiLinkVariant } from '@mdi/js'
import { ref, watch } from '@vue/composition-api'
import TipoSolicitacaoService from '@/services/modules/TipoSolicitacaoService'

export default {
  props: {
    tipoSolicitacaoData: {
      type: Object,
      default: () => {},
    },
  },

  setup(props, { emit }) {
    const tipoSolicitacaoDataLocale = ref({})

    const resetForm = () => {
      tipoSolicitacaoDataLocale.value = {}
    }

    const loading = ref(false)

    async function update() {
      const request = {
        nome: tipoSolicitacaoDataLocale.value.nome,
        descricao: tipoSolicitacaoDataLocale.value.descricao,
        filaId: tipoSolicitacaoDataLocale.value.filaId,
      }

      try {
        loading.value = true
        await TipoSolicitacaoService.update(tipoSolicitacaoDataLocale.value.id, request)
        loading.value = false
      } finally {
        emit('update:active-tab', 1)
      }
    }

    watch(() => props.tipoSolicitacaoData, async value => {
      tipoSolicitacaoDataLocale.value = value
    }, { immediate: true })

    return {
      tipoSolicitacaoDataLocale,
      icons: {
        mdiClose,
        mdiLinkVariant,
      },
      resetForm,
      update,
      loading,
    }
  },
}
</script>
